// removed by extract-text-webpack-plugin
module.exports = {"input":"style-input__input___2thNN","large":"style-input__large___tUmCE","fill":"style-input__fill___1lQ9V","suggestionsContainer":"style-input__suggestionsContainer___2e43q","suggestion":"style-input__suggestion___2Wm71","suggestionHighlighted":"style-input__suggestionHighlighted___1okS4"};


//////////////////
// WEBPACK FOOTER
// ./js/components/style-input/style-input.scss
// module id = 223
// module chunks = 0 1